import React from 'react';
import { StyledFormErrorLabel } from './styles';

interface IFormLabel {
  label: string;
  name?: string;
  style?: any;
}

const FormErrorLabel = ({ label, name = '', style }: IFormLabel) => (
  <StyledFormErrorLabel style={{ ...style }} htmlFor={name}>
    {label}
  </StyledFormErrorLabel>
);

export default FormErrorLabel;
